/**
 * Piagnet Web UI - Main Entry Point
 */

// Import components
import { Layout } from "./components/Layout.js";
import { Dashboard } from "./components/Dashboard.js";
import { AgentConfig } from "./components/AgentConfig.js";

// Import stores
import { gatewayStore } from "./stores/gateway-store.js";

// Export for global access
declare global {
	interface Window {
		piagnetStore: typeof gatewayStore;
	}
}

// Make store available globally for debugging
if (typeof window !== "undefined") {
	window.piagnetStore = gatewayStore;
}

// Components are auto-registered via @customElement decorator
// This file serves as the entry point that imports all modules

console.log("Piagnet Web UI loaded");

// Auto-connect to gateway if running
if (typeof window !== "undefined") {
	// Small delay to let components initialize first
	setTimeout(() => {
		gatewayStore.connect().catch((err) => {
			console.warn("Failed to connect to gateway:", err);
		});
	}, 100);
}

export { Layout, Dashboard, AgentConfig, gatewayStore };
